"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("react-calendar/dist/Calendar.css");

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

require("./DatePicker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _DatePicker["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/dist/entry.js
// module id = 753
// module chunks = 0